import { createStore } from 'vuex'
// 文档初始化数据
const defaultDocStore:any = {
  // 文档使用模式：pdfPrint
  docUseMode: '',
  // 正文可视区域第一个元素
  firstDomOnViewport: null,
  // 编辑器错误
  editorError: false,
  // 插入菜单模块排除功能
  excludeInsertBlockItems: [],
  backMenuState: false,
  finishState: false,
  // 文档加载完
  docLoadedState: false,
  personInfo: {
    deptInfo: [{}]
  },
  editUsers: [],
  editStatus: '',
  href: null,
  isHideTopToolBar: false, // 是否隐藏顶部工具栏
  isShowTextToolBarComponent: false, // 判断悬浮框是否展示的值
  hideTextToolBar: true, // 判断悬浮框是否隐藏的值
  linkComponentPosition: {
    isHideLinkComponent: true,
    isHideTextInput: false,
    textInputFocus: false,
    linkInputFoucs: false
  },
  linkPosition: {},
  linkInput: {
    linkInputText: '',
    linkInputLink: ''
  },
  taskTableComState: 'hide',
  // 内容窗是否显示状态
  contentPanelState: 'hide',
  mapComState: 'hide',
  mapComData: {},
  linkBlock: null,
  selectInfo: null,
  selectBlockInfo: null,
  officeBlock: [],
  otherOfficeBlock: null,
  officeViewFrom: null,
  onlineState: true,
  mouseoverBlock: null, // 记录当鼠标移入到每一个block的时候对应的block信息
  imgMouseoverBlock: null, // 记录当鼠标移入到img的时候对应的block信息
  fontColorRelation: {
    // 和字体颜色组件关联的数据
    fontColorTopToolBarShow: false,
    fontColorTextToolBarShow: false,
    whichActive: 1,
    colorStyle: ['#eb3223', 'style-color-0']
  },
  bgColorRelation: {
    // 和背景颜色组件关联的数据
    bgColorTopToolBarShow: false,
    bgColorTextToolBarShow: false,
    whichActive: 9,
    colorStyle: ['#ffe662', 'style-bg-color-9']
  },
  tableBg: {
    bgColorTopToolBarShow: false,
    bgColorTextToolBarShow: false,
    whichActive: 9,
    tableBgActive: 9,
    colorStyle: ['#ffe662', 'style-bg-color-9']
  },
  tableCellBg: {
    tableCellBgTextToolBarShow: false,
    whichActive: 9,
    tableBgActive: 9
  },
  formatType: {} as any, // 存储格式刷内容
  formatStatus: 0, // 存储格式刷状态
  toolbarLightState: null, // 工具栏高亮状态
  personTab: 0, // 存储人员选择框状态
  showTableDialog: false, // 设置是否展示table的dialog
  selectLineType: null, // 判断选中的的元素是一行还是多行
  isFullScreen: false, // 是否全屏标识
  isHistoryIng: false, // 是否正在查看历史模式
  isExcelHistoryIng: false, // 是否正在查看Excel历史模式
  shareInfo: {}, // 分享弹框信息
  showShareDialog: false, // 是否显示分享确认弹框
  commonWebMenuPosition: null, // 通用网页菜单位置
  hiddenCommonWebMenu: 0, // 通用网页菜单隐藏标志
  commonWebMenuData: null, // 通用网页菜单数据
  commonWebMenuCode: null, // 鼠标所在的通用网页 业务menuCode
  commonWebBarTimer: null, // 通用网页悬浮窗timer
  commonWebLightMenuCode: null, // 通用网页菜单的高亮menuCode
  uploadFileInfo: {
    fileName: '--',
    precent: 0,
    nowSize: 0,
    totalSize: 0,
    speed: '--'
  },
  openNewFileUrl: '',
  isShowFileUrlSearch: false,
  cancelEvent: null, // 取消上传事件
  isSelectedLink: false, // 判断选中的元素中是否含有链接
  dataType: null, // 记录点击当前元素后，当前元素的数据类型
  inTable: null, // 记录点击当前元素后，当前元素是否在table中(解决table中不可继续插入table问题)，string类型；两个值：table 或 null
  isShowCommitFlag: false, // 编辑器右侧是否显示了评论
  commentAtList: [] as any[], // 评论@人员列表
  isIE: false,
  hideHeader: false, // 隐藏文档header
  beforeDisabledToolTip: null,
  excelToobarStatus: {} as any,
  excelToobarFilterStatus: {} as any,
  mergeCellsCanUse: false, // 判断合并单元格按钮是否可用
  excelFontColor: '#EB4334',
  excelBgColor: '#FFFA2B',
  excelBorder: 'all-border',
  excelCommentsIsShow: false,
  isMouseDown: false, // 判断当前鼠标是否是mousedown状态
  allowRestore: true, // 从外部接收历史记录交互控制字段
  isFocusLocked: false, // 是否聚焦在锁定单元格
  isTableRight: false, // 用这个值来判断当表格内的悬浮工具栏在窗口最右侧时候做判断
  isChangeSubMenuPosition: false, // 用这个值来判断当表格内的文字类悬浮工具栏在窗口最右侧时候做判断
  cancelTokenArr: [] as any, // 首页切换tab时取消上次的请求
  isWordIconDisable: false, // 设置工具栏按钮是否可用（应对锁定功能）
  lockUserId: '', // 设置选中的文本有没有被锁定人信息（应对锁定功能）
  businessParameterAuth: false, // 是否有设置参数域的权限
  editorHasLock: false,
  showPpt: true,
  pptComplete: true,
  pasteState: true, // 粘贴操作是否正常
  pushTaskData: {
    messageType: 'pushTask',
    isShowPushTask: false,
    taskData: {
      spaceName: '',
      spaceId: '1387594258789306368',
      source: '301',
      sourceBizId: '',
      sourceBizName: '',
      sourceBizTime: ''
    }
  }, // 任务推送组件数据
  removeLockClass: false,
  showParameterDomain: false, // 是否显示参数域列表
  tablePosition: null, // 记录光标在表格中的位置，为表格悬浮工具栏中的单元格弹窗在哪展示做准备
  isSelectedMergeCell: false,
  addRowList: [] as any,
  pushedTasks: [] as any,
  currentImageBlock: {imgSrc: '', blockData: {}}, // 记录当前点击选中的图片block
  securityConfig: { commentPermission: 10, sharePermission: 20, safePermission: 20, fileId: '' },
  selectShareConfigInfo: {sharePermission: 20, safePermission: 20},
  dataValidationStatus: false,
  formatStatusCanUse: true // 格式刷是否可用
}
export default createStore({
  state: {
    // 当前链接
    originUrl: '',
    // 子文档列表
    childDocList: [],
    // 根文档编辑器滚动位置记录
    editorScrollPosition: null,
    // 任务一览是否显示状态
    childDocTaskState: 'hide',
    // 文档信息
    docInfo: {
      name: '',
      fileId: '',
      locked: null,
      sendNotice: true,
      createTime: '',
      sendTask: false,
      systemCode: null,
      extendInfo: null
    },
    // 文档权限 coede: 200  成功 5004  无权限 5007  链接失效 5008  密码错误 5009  输入密码
    docAuth: {
      data: {
        roleCode: '',
        token: '',
        fileId: '',
        authCodes: []
      }
    },
    // 文档更新时间
    updateTime: null,
    fileTypeFlag: '', // 文件类型
    clientInfo: {
      name: '',
      version: 0
    },
    userInfo: {
      deptInfo: [{}],
      name: '',
      lxAccount: '',
      portraitUrl: ''
    },
    otherSystem: {
      appName: '',
      hideHeader: false,
      showCataLog: true,
      removeRight: false,
      titleInEditor: true, // 是否展示标题
      isInitShrinkHeader: false,
      isShowHeaderAvator: true, // 是否显示头像
      isShowOperation: true, // 是否显右侧操作功能
      isShowScreenPlayer: true, // 是否演示功能
      isShowCreateAndImport: true, // 是否显示创建文档和导入功能
      isShowMoreDownPull: true, // 是否更多下拉功能
      isShowUserList: true, // 是否显示协同列表
      isShowShare: true, // 是否显示分享
      isShowFileStatus: true, // 是否显示文件状态
      isShowCollect: true, // 是否显示收藏
      isShowYunTuSuoLogo: true, // 是否显示log
      isShowDocName: true, // 是否显示文件名
      isShowBackMenu: true, // 是否显示返回菜单
      isShowCatalogName: true, // 是否显示目录名称
      showComment: true, // 是否显示行末批注按钮
      exportExcel: true, // 是否下载excel
      isShowDownloadPreview: false, // 是否拥有下载前预览
      isShowSetHeaderFooterPage: false, // 是否拥有设置页眉页脚
      isShowInsertPageBreak: false, // 是否拥有插入分页符功能
      isShowDataVerify: true, // 是否有数据按钮功能
      operationType: '', // 外部系统定义调用能力的类型
      source: '', // 创建会议的source来源
      exportFileName: '' // 外部系统定义导出文件的名称
    }, // 其他系统接入word组件的入参
    outerSystemData: null, // 外层业务系统信息
    currentDocHistoryInfo: {}, // 查看文档历史记录信息的docInfo
    // 文档初始化需要信息
    ...defaultDocStore
  },
  mutations: {
    // 设置历史记录页面采用的文档信息
    setCurrentDocHistoryInfo(state, data) {
      const copyData = JSON.parse(JSON.stringify(data))
      state.currentDocHistoryInfo = copyData
    },
    // 文档初始化需要信息
    initDocStore(state) {
      for (const key of Object.keys(defaultDocStore)) {
        state[key] = defaultDocStore[key]
      }
    },
    setDocUseMode(state, data) {
      state.docUseMode = data
    },
    setFirstDomOnViewport(state, data) {
      state.firstDomOnViewport = data
    },
    setEditorError(state, data) {
      state.editorError = data
    },
    setExcludeInsertBlockItems(state, data) {
      state.excludeInsertBlockItems = data
    },
    setClient(state, data) {
      state.clientInfo = data
    },
    setIsFocusLocked(state, data) {
      state.isFocusLocked = data
    },
    setAddRowList(state, data) {
      for (let i = 0; i < state.addRowList.length; i++) {
        if (state.addRowList[i] >= data.row) {
          state.addRowList[i] += data.rowCount
        }
      }
      for (let j = 0; j < data.rowCount; j++) {
        state.addRowList.push(data.row + j)
      }
      state.addRowList.sort()
    },
    deleteAddRowList(state, data) {
      for (let i = 0; i < data.rowCount; i++) {
        const rowIndex = state.addRowList.indexOf(data.row + i)
        if (rowIndex >= 0) {
          state.addRowList.splice(rowIndex, 1)
        }
      }
    },
    clearAddRowList(state) {
      state.addRowList = []
    },
    setPasteState(state, data) {
      state.pasteState = data
    },
    setExcelToobarStatus(state, data) {
      state.excelToobarStatus = data
    },
    setExcelToobarMergeStatus(state, data) {
      state.excelToobarStatus['merge-cells'] = data
    },
    setExcelToobarFilterStatus(state, data) {
      state.excelToobarFilterStatus = data
    },
    setExcelCommentsIsShow(state, data) {
      state.excelCommentsIsShow = data
    },
    setExcelFontFamily(state, data) {
      state.excelToobarStatus['font-family'] = data
    },
    setExcelFontSize(state, data) {
      state.excelToobarStatus['font-size'] = data
    },
    setExcelFontColor(state, data) {
      state.excelFontColor = data
    },
    setExcelBgColor(state, data) {
      state.excelBgColor = data
    },
    setExcelBorder(state, data) {
      state.excelBorder = data
    },
    setIsIE(state, data) {
      state.isIE = data
    },
    setCommonWebLightMenuCode(state, data) {
      state.commonWebLightMenuCode = data
    },
    setCommonWebBarTimer(state, data) {
      state.commonWebBarTimer = data
    },
    setCommonWebMenuCode(state, data) {
      state.commonWebMenuCode = data
    },
    setCommonWebMenuData(state, data) {
      state.commonWebMenuData = data
    },
    setHiddenCommonWebMenu(state) {
      state.hiddenCommonWebMenu += 1
    },
    setCommonWebMenuPosition(state, data) {
      state.commonWebMenuPosition = data
    },
    showConfirmShare(state, data) {
      state.shareInfo = data
    },
    setShareDialog(state, data) {
      state.showShareDialog = data
    },
    setIsHideTopToolBar(state, data) {
      // 判断是否展示顶部工具栏
      state.isHideTopToolBar = data
    },
    setIsShowTextToolBarComponent(state, data) {
      state.isShowTextToolBarComponent = data
    },
    setHideTextToolBar(state, data) {
      state.hideTextToolBar = data
    },
    setCopyHref(state, data) {
      state.href = data
    },
    setBackMenuState(state, data) {
      state.backMenuState = data
    },
    setFinishState(state, data) {
      state.finishState = data
    },
    setDocLoadedState(state, data) {
      state.docLoadedState = data
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setEditUsers(state, data) {
      state.editUsers = data
    },
    setOriginUrl(state, data) {
      state.originUrl = data
    },
    setPersonInfo(state, data) {
      state.personInfo = data
    },
    setUpdateTime(state, data) {
      state.updateTime = data
    },
    setEditStatus(state, data) {
      state.editStatus = data
    },
    setLinkPosition(state, data) {
      state.linkPosition = data
    },
    setLinkBlock(state, data) {
      state.linkBlock = data
    },
    saveSelectInfo(state, data) {
      state.selectInfo = data
    },
    saveSelectBlockInfo(state, data) {
      state.selectBlockInfo = data
    },
    setLinkInputInfo(state, data) {
      state.linkInput = data
    },
    setDocInfo(state, data) {
      state.docInfo = data
    },
    setCatalogTree(state, data) {
      state.catalogTree = data
    },
    setCatalogItemId(state, data) {
      state.catalogItemId = data
    },
    setDocName(state, data) {
      state.docInfo.name = data
    },
    setLinkComponentPosition(state, data) {
      state.linkComponentPosition = data
    },
    setTaskTableComState(state, data) {
      state.taskTableComState = data
    },
    setMapComState(state, data) {
      state.mapComState = data
    },
    setMapComData(state, data) {
      state.mapComData = data
    },
    setContentPanelState(state, data) {
      state.contentPanelState = data
    },
    setChildDocList(state, data) {
      state.childDocList = data
    },
    setEditorScrollPosition(state, data) {
      state.editorScrollPosition = data
    },
    setChildDocTaskState(state, data) {
      state.childDocTaskState = data
    },
    setOfficeBlock(state, data) {
      state.officeBlock = data
    },
    setOnlineState(state, data) {
      state.onlineState = data
    },
    // 记录当鼠标移入到每一个block的时候对应的block信息
    setMouseoverBlock(state, data) {
      state.mouseoverBlock = data
    },
    // 记录当鼠标移入到图片block的时候对应的block信息
    setImgMouseoverBlock(state, data) {
      state.imgMouseoverBlock = data
    },
    // 和字体颜色相关的state
    setFontColorRelation(state, data) {
      state.fontColorRelation = data
    },
    // 和字体颜色index
    setFontColorRelationIndex(state, data) {
      state.fontColorRelation.whichActive = data
    },
    // 和背景颜色相关的state
    setBgColorRelation(state, data) {
      state.bgColorRelation = data
    },
    setTableBg(state, data) {
      state.tableBg = data
    },
    setTableBgActive(state, data) {
      state.tableBg.tableBgActive = data
    },
    // 表格悬浮工具栏的单元格背景颜色
    setTableCellBg(state, data) {
      state.tableCellBg = data
    },
    // 和背景颜色index
    setBgColorRelationIndex(state, data) {
      state.bgColorRelation.whichActive = data
    },
    // 存储文档权限
    setDocAuth(state, auth) {
      if (!auth.data) {
        auth.data = { roleCode: '' }
      }
      state.docAuth = auth
    },
    // 更改只读状态
    setReadAuth(state, data) {
      state.docAuth.data.roleCode = data
    },
    // 更改锁定状态
    setLockStatus(state, data) {
      state.docInfo.locked = data
    },
    setFormatType(state, data) {
      state.formatType = data
    },
    setFormatStatus(state, data) {
      // 没有选中格式刷
      if (data === 0) {
        state.excelToobarStatus['format-status'] = false
      }
      // 单击选中格式刷
      if (data === 1) {
        state.excelToobarStatus['format-status'] = true
      }
      // 双击选中格式刷
      if (data === 2) {
        state.excelToobarStatus['format-status'] = true
      }
      state.formatStatus = data
    },
    setFormatStatusCanUse(state, data) {
      // 格式刷是否可用
      state.formatStatusCanUse = data
    },
    setToolbarLightState(state, data) {
      state.toolbarLightState = data
    },
    setPersonTab(state, data) {
      state.personTab = data
    },
    // 设置是否展示table的dialog
    setShowTableDialog(state, data) {
      state.showTableDialog = data
    },
    // 设置字体颜色和背景颜色下拉框都隐藏的函数
    setFontAndBgClose(state, data) {
      // 和字体颜色组件关闭
      state.fontColorRelation = data[0]
      // 和背景颜色组件关闭
      state.bgColorRelation = data[1]
      // 表格颜色组件关闭
      state.tableBg = data[2]
      // 表格悬浮工具栏中的单元格背景色组件关闭
      state.tableCellBg = data[3]
    },
    setSelectLineType(state, data) {
      state.selectLineType = data
    },
    setFullScreen(state, data) {
      state.isFullScreen = data // 修改是否全屏标识
    },
    setHistoryIng(state, data) {
      state.isHistoryIng = data // 修改历史状态
    },
    setExcelHistoryIng(state, data) {
      state.isExcelHistoryIng = data // 修改Excel历史状态
    },
    setUploadFileInfo(state, data) {
      state.uploadFileInfo = data // 上传文件的进度，大小等信息
    },
    setOpenNewFile(state, data) {
      state.openNewFileUrl = data // 打开新文档的url地址
    },
    setIsShowFileUrlSearch(state, data) {
      state.isShowFileUrlSearch = data
    },
    setCancelEvent(state, data) {
      state.cancelEvent = data
    },
    setIsSelectedLink(state, data) {
      state.isSelectedLink = data
    },
    setDataType(state, data) {
      state.dataType = data
    },
    setInTable(state, data) {
      state.inTable = data
    },
    setShowCommitFlag(state, data) {
      state.isShowCommitFlag = data
    },
    setCommentAtList(state, data) {
      state.commentAtList.push(data)
    },
    clearCommentAtList(state) {
      state.commentAtList = []
    },
    setHideHeader(state, data) {
      state.hideHeader = data
    },
    setFileTypeFlag(state, data) {
      state.fileTypeFlag = data
    },
    setBeforeDisabledToolTip(state, data) {
      state.beforeDisabledToolTip = data
    },
    setAllowRestore(state, data) {
      state.allowRestore = data
    },
    setOtherSystem(state, data) {
      state.otherSystem = data
    },
    setOuterSystemData(state, data) {
      state.outerSystemData = data
    },
    setIsMouseDown(state, data) {
      state.isMouseDown = data
    },
    setMergeCellsCanUse(state, data) {
      state.mergeCellsCanUse = data
    },
    setIsTableRight(state, data) {
      state.isTableRight = data
    },
    setIschangeSubMenuPosition(state, data) {
      state.isChangeSubMenuPosition = data
    },
    addCancelToken(state, data) {
      const cancelUrl = [
        '/cooperation/v1/document/getMyFileListByPage', // 首页我创建的列表
        '/cooperation/v1/document/filePreviewReordOnlineList', // 最近浏览文档
        '/cooperation/v1/user/info/filePreviewReordOnlineList', // 搜索
        '/cooperation/v1/user/info/getMyCollectionByPage' // 收藏接口
      ]
      cancelUrl.forEach(item => {
        if (data.url && data.url.includes(item)) {
          state.cancelTokenArr.push(data)
        }
      })
    },
    clearCancelToken(state) {
      state.cancelTokenArr.map((item: any) => {
        item.cancel(`${item.url}---路由切换取消请求`)
      })
      state.cancelTokenArr = []
    },
    // 设置word部分的按钮是否可用状态（为了应对锁定功能做的）
    setWordIconDisable(state, data) {
      state.isWordIconDisable = data
    },
    // 选中的文档被锁定人信息
    setLockUserId(state, data) {
      state.lockUserId = data
    },
    // 是否有设置参数域的权限
    setBusinessParameterAuth(state, data) {
      state.businessParameterAuth = data
    },
    editorHasLock(state, data) {
      state.editorHasLock = data
    },
    setShowPpt(state, data) {
      state.showPpt = data
    },
    setPptComplete(state, data) {
      state.pptComplete = data
    },
    setPushTaskData(state, data) {
      state.pushTaskData = data
    },
    setRemoveLockClass(state, data) {
      state.removeLockClass = data
    },
    setShowParameterDomain(state, data) {
      state.showParameterDomain = data
    },
    setTablePosition(state, data) {
      state.tablePosition = data
    },
    setSelectedMergeCell(state, data) {
      state.isSelectedMergeCell = data
    },
    setPushedTasks(state, data) {
      state.pushedTasks = data
    },
    addPushedTasks(state, data) {
      state.pushedTasks.push(data)
    },
    // 记录当前点击的图片
    setCurrentImageBlock(state, data) {
      state.currentImageBlock = data
    },
    setSecurityConfig(state, data) {
      state.securityConfig = {...state.securityConfig, ...data}
    },
    setSelectShareConfigInfo(state, data) {
      state.selectShareConfigInfo = {...state.selectShareConfigInfo, ...data}
    },
    setDataValidationStatus(state, data) {
      state.dataValidationStatus = data
    }
  },
  getters: {
    isSendIm(state) {
      // 不需要发IM的系统集合
      const sendNoticeSystemCodes = ['100005']
      const systemCode = state.docInfo.systemCode + ''
      return sendNoticeSystemCodes.indexOf(systemCode) === -1
    },
    isReadAuthFlag(state) {
      const roleCode = state.docAuth.data.roleCode
      return roleCode === 'c' || roleCode === 'r'
    }
  }
})
